import {Button, Container, createMuiTheme, Grid, TextField, ThemeProvider} from '@material-ui/core';
import {green} from '@material-ui/core/colors';
import * as PCI from 'ApplicationEntry/ducks/planCode';
import * as PC from 'ApplicationEntry/ducks/planCodes';
import {PlanCodeItem} from 'ApplicationEntry/models/PlanCode';
import React from 'react';
import {useDispatch} from 'react-redux';
import Dialog from 'Shared/components/Dialog/Dialog';
import './PlanCodeSection.sass';

const theme = createMuiTheme({
  palette: {
    primary: green,
  },
});

type DialogProps = {
  dialogOpen: boolean;
  dialogClose: () => void;
  index: number;
  planCodeItem: PlanCodeItem;
};

const PlanCodeDialog = ({dialogOpen, dialogClose, index, planCodeItem}: DialogProps) => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dialogClose();
  };

  const handleSave = () => {
    dispatch(PC.updatePlanCode(index, planCodeItem.units));
    dialogClose();
  };

  const hasOnTheJobRider =
    planCodeItem.onTheJobRiderBenefit > 0 &&
    (planCodeItem.planCode.value === 'RSA' ||
      planCodeItem.planCode.value === 'RSB' ||
      planCodeItem.planCode.value === 'RSC' ||
      planCodeItem.planCode.value === 'RSD');

  return (
    <Dialog fullScreen open={dialogOpen} onClose={handleCancel} title="Update Plan Code">
      <Container id="plan-Code-section__dialog-container" maxWidth={false}>
        <form noValidate autoComplete="off" className="plan-Code-section__view-form">
          <div className="plan-Code-section__view-form-row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <TextField
                  id="phase"
                  label="Phase"
                  variant="outlined"
                  placeholder="Phase"
                  margin="normal"
                  fullWidth
                  className="plan-Code-section__view-form-text-field"
                  value={planCodeItem.phase.value}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="plan-code"
                  label="Plan Code"
                  variant="outlined"
                  placeholder="Plan Code"
                  margin="normal"
                  fullWidth
                  className="plan-Code-section__view-form-text-field"
                  value={planCodeItem.planCode.value}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="units"
                  label="Units"
                  variant="outlined"
                  placeholder="Units"
                  margin="normal"
                  fullWidth
                  className="plan-Code-section__view-form-text-field"
                  value={planCodeItem.units}
                  onChange={e => dispatch(PCI.changeUnits(Number(e.target.value)))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="description"
                  label="Description"
                  variant="outlined"
                  placeholder="Description"
                  margin="normal"
                  fullWidth
                  className="plan-Code-section__view-form-text-field"
                  value={planCodeItem.description.value}
                />
              </Grid>
              {hasOnTheJobRider && (
                <Grid item xs={12} md={3}>
                  <TextField
                    id="on-the-job-rider-benefit"
                    label="On-the-Job Rider Benefit"
                    variant="outlined"
                    placeholder="On-the-Job Rider Benefit"
                    margin="normal"
                    fullWidth
                    className="plan-Code-section__view-form-text-field"
                    value={planCodeItem.onTheJobRiderBenefit}
                  />
                </Grid>
              )}
            </Grid>
          </div>
        </form>

        <div className="plan-Code-section__buttons-container">
          <Grid container direction="row" justify="flex-end" alignItems="center">
            <Button
              variant="contained"
              color="inherit"
              onClick={handleCancel}
              className="plan-Code-section__buttons"
              id="plan-Code-section__buttons-cancel"
            >
              Cancel
            </Button>
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                className="plan-Code-section__buttons"
                onClick={handleSave}
                id="plan-Code-section__buttons-save"
              >
                Save Changes
              </Button>
            </ThemeProvider>
          </Grid>
        </div>
      </Container>
    </Dialog>
  );
};

export default PlanCodeDialog;
